import { render } from "./SystemPerformanceSection.vue?vue&type=template&id=b48f0cd6&scoped=true"
import script from "./SystemPerformanceSection.vue?vue&type=script&lang=js"
export * from "./SystemPerformanceSection.vue?vue&type=script&lang=js"

import "./SystemPerformanceSection.vue?vue&type=style&index=0&id=b48f0cd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48f0cd6"]])

export default __exports__